import { Injectable } from '@angular/core';
import { AbstractFacade } from './abstract.facade';
import { FacadeFactory } from './facade.factory';


export enum AVAILABLE_FACADE {
  USER_FACADE = 'user-facade',
  BADGES_FACADE = 'badges-facade',
  VIDEOS_FACADE = 'videos-facade',
  COACHING_VIDEOS_FACADE = 'coaching-videos-facade',
  ACTIVITIES_FACADE = 'activities-facade',
  ACTIVITIES_BY_MONTH_FACADE = 'activities-by-month-facade',
  GPS_TRACKS_FACADE = 'gps-tracks-facade',
  PLAYLISTS_FACADE = 'playlists-facade',
  WORKOUTS_FACADE = 'workouts-facade',
  CONTRIBUTION_FACADE = 'contribution-facade',
  STATS_FACADE = 'stats-facade',
}

interface AccessedFacade {
  lastAccess: number;
  ttl: number;
  facade: AbstractFacade;
}

// Default facade TTL after access in ms
const DEFAULT_FACADE_TTL = 90000;

/**
 * It facade that can't managed by angular injector
 */
@Injectable({
  providedIn: 'root',
})
export class FacadesRegistry {
  private readonly registryMap = new Map<string, AccessedFacade>();

  constructor(
    private readonly facadeFactory: FacadeFactory,
  ) {}

  add(facade: any, key: string) {
    this.registryMap.set(key, facade);
  }

  get<T>(key: string, options: {ttl?: number} = {}): T {
    const facadeAccessInfo = this.registryMap.get(key);
    if (facadeAccessInfo) {
      // If new access update last time access
      facadeAccessInfo.lastAccess = new Date().getTime();
      return facadeAccessInfo.facade as any as T;
    }
    const [facadeName, id] = key.split('/');
    const createdFacade = this.facadeFactory.create<T>(facadeName, { id });
    this.registryMap.set(key, {
      lastAccess: new Date().getTime(),
      ttl: options.ttl ?? DEFAULT_FACADE_TTL,
      facade: createdFacade as any as AbstractFacade
    });
    return createdFacade;
  }

  remove(key: string): boolean {
    return this.registryMap.delete(key);
  }

  getAllEntries(): IterableIterator<[string, AccessedFacade]> {
    return this.registryMap.entries();
  }
}
